import type { DtoAdminLoanSummary } from "@porchpass/api-client";

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatLoanTerm(months: number): string {
  if (months % 12 === 0) {
    const years = months / 12;
    return `${years} yr`;
  }
  return `${months} mo`;
}

export function formatLoanDetails(
  loan: DtoAdminLoanSummary | null | undefined,
): string {
  if (!loan) {
    return "Not available";
  }

  const parts: string[] = [];
  if (loan.loan_amount != null && loan.loan_amount > 0) {
    parts.push(formatCurrency(loan.loan_amount));
  }
  if (loan.interest_rate != null && loan.interest_rate > 0) {
    parts.push(`${loan.interest_rate.toFixed(2)}%`);
  }
  if (loan.term_months != null && loan.term_months > 0) {
    parts.push(formatLoanTerm(loan.term_months));
  }

  return parts.length > 0 ? parts.join(" · ") : "Not available";
}

export function formatDate(iso: string): string {
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(new Date(iso));
}

const STATUS_LABELS: Record<string, string> = {
  not_done: "Not Done",
  in_progress: "In Progress",
  in_review: "In Review",
  done: "Done",
  cancelled: "Cancelled",
  correction_needed: "Correction Needed",
};

export function formatStatusLabel(status: string): string {
  return STATUS_LABELS[status] ?? status;
}

export function formatRelativeTime(iso: string): string {
  const diffMs = Date.now() - new Date(iso).getTime();
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 1) return "just now";
  if (diffMin < 60) return `${diffMin} min ago`;
  const diffHours = Math.floor(diffMin / 60);
  if (diffHours < 24) return `${diffHours} hr ago`;
  const diffDays = Math.floor(diffHours / 24);
  return `${diffDays} day${diffDays === 1 ? "" : "s"} ago`;
}
